module.exports = __webpack_public_path__ + "img/ic_online.4d577ff4.png";